export default "__VITE_ASSET__1c5188ed__"